import { useState, useEffect } from "react";
import {useToast} from "../../../components/notificaciones/ToastProvider";
import { axiosInstance } from "../../../components/helpers/axiosInstance";
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import { Toggle } from "rsuite";
import 'rsuite/Toggle/styles/index.css';
import { useContratos } from "../../../components/contratos/ContratosProvider";

/**
 * COMPONENTE PRINCIPAL
 * @param contrato
 * @returns {JSX.Element}
 * @constructor
 */
export default function OnOff({
   contrato
}) {
    /**
     * Guardar el estado del contrato
     */
    const [check, setCheck] = useState(false); //contrato.activo === 1
    /**
     * Hook de notíficaciones
     * @type {undefined}
     * @property setArrayToast
     */
    const toastP = useToast();
    /**
     * Usar función handleChangeState
     * @function handleChangeState Cambiar datos en Storage y actualizar array de contratos
     */
    const contextContrato = useContratos();
    /**
     * Cambiar estado de switch
     */
    useEffect(() => {
        setCheck(Boolean(contrato.vigente));
    }, [contrato.vigente]);
    /**
     * @function onOff activar o desactivar contrato
     */
    function onOff() {
        axiosInstance.patch('/contratos/OnOff', {
            "id_cliente": contrato.id_cliente,
            "ids_contratos": contrato.id_contrato,
            "accion": contrato.vigente ? 'desactivar' : 'activar'
        }).then(
            /**
             * @param res
             * @param res.data
             * @param res.status
             * @param res.data.vigente
             */

            (res) => {
                if(res.status === 200){
                    /**
                     * Actualizar color y estado de checkbox
                     * @type {boolean}
                     */
                    const act = Boolean(res.data[0].vigente);
                    setCheck(act)
                    /**
                     * Notificación : Se cambio el estado del cliente
                     */
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id: contrato.id_contrato,
                                text: 'El contrato de ' + contrato.cliente.cliente + ' se ha ' + ( contrato.vigente ? 'desactivado' : 'activado'),
                                color: 'success',
                                show: true }
                        ]
                    );
                    /**
                     * Función para cambiar los nuevos datos del contrato
                     */
                    contextContrato.handleChangeState(contrato.id_contrato, res.data[0].vigente, contrato.ultimo_pago, contrato.hasta, contrato.promesa);
                }
            }).catch((err) => {
            /**
             * Notificación : hubo un problema (muestra el error de API)
             */
            toastP.setArrayToast(
                prevToasts => [
                    ...prevToasts,
                    {
                        id: contrato.id_contrato,
                        text: 'Algo salió mal: ' + err.data,
                        color: 'danger',
                        show: true }
                ]
            );
        });
    }

    return(
        <>
            <style type={'text/css'}>
                {`
                    .rs-toggle-presentation {
                        background-color: var(--bs-danger)!important;
                    }
                    
                    .rs-toggle-checked .rs-toggle-presentation {
                        background-color: var(--bs-success)!important;
                    }
                `}
            </style>
            <TitleTooltip title={contrato.vigente ? 'Desactivar contrato' : 'Activar contrato'} placement={'bottom'}>
                <div>
                    <Toggle
                        id={'onOff'}
                        checked={check}
                        onChange={onOff}//{handleChange}
                        size={'md'}
                    />
                </div>
            </TitleTooltip>

            {/*<Modal*/}
            {/*    show={show} onHide={() => setShow(false)}*/}
            {/*    keyboard={false}*/}
            {/*    backdrop={'static'}*/}
            {/*    contentClassName={'mw-75'}*/}
            {/*>*/}
            {/*    <Modal.Header closeButton/>*/}
            {/*    <Modal.Body className={"d-grid fs-3 align-content-center justify-content-center"}>*/}
            {/*            <i className="bi bi-gear fs-2tx text-warning mx-auto py-2"></i><br/>*/}
            {/*            <span className={'py-2'}>¿{check ? 'Desactivar' : 'Activar'} contrato?</span>*/}
            {/*    </Modal.Body>*/}
            {/*    <Modal.Footer className={'p-4 justify-content-center gap-4'}>*/}
            {/*        <button type={'button'}*/}
            {/*                className={"btn btn-secondary btn-active-light-secondary"}*/}
            {/*                onClick={() => setShow(false)}>*/}
            {/*            Cancelar*/}
            {/*        </button>*/}
            {/*        <button type={'button'} onClick={onOff}*/}
            {/*                className={"btn btn-primary btn-active-light-primary"}>*/}
            {/*            Confirmar*/}
            {/*        </button>*/}
            {/*    </Modal.Footer>*/}
            {/*</Modal>*/}
        </>
    );
}
